import React from 'react';
import styled from 'styled-components';
import MobileMenu from "../MobileMenu";
import logoImg from '../../../../assets/img/logo/logo1.webp'
import RenderMedia from "../../../media/renderMedia";


const Ul = styled.ul`
  list-style: none;
  overflow-y: auto;
  font-size: 15px;
  display: flex;
  flex-flow: row nowrap;
  padding-right: 0;
  li {
    padding: 18px 10px;
  }
  flex-flow: column nowrap;
    background-color: #333;
    box-shadow: 0px 5px 2px 3px #333;
    position: fixed;
    transform: ${({open}) => open ? 'translateX(0)' : 'translateX(100%)'};
  top: -12px;
  right: ${({open}) => open ? '-10px' : "-100%" } ;
  height: 101vh;
  width: 270px;
  padding-top: 3.5rem;
  transition: transform 0.3s ease-in-out;
  z-index: 99998;

  li {
    color: #000;
  }
`;

const RightNav = ({logo, toggle, open}) => {

    return (
        <>
            <Ul open={open}>
                <div className="mb-2 text-center">
                    <img src={logoImg} alt="logo" title="logo" width={100}/>
                </div>
                <MobileMenu toggleMenu={toggle}/>
                <div className='nav-social mb-3'>
                    <RenderMedia />

                </div>
            </Ul>

        </>
    )
}

export default RightNav
